import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { ExplainVideoView } from './lcExplainVideos'

function path(learnerId: number, componentProgressId: number): string {
  return `/lc/admin/coaching/learners/${learnerId}/component-progress/${componentProgressId}/explain-videos`
}

export async function listCoachingVideos(learnerId: number, componentProgressId: number): Promise<ExplainVideoView[]> {
  const response = await apiClient.get<ApiResponse<ExplainVideoView[]>>(path(learnerId, componentProgressId))
  return response.data.data
}

export async function retryCoachingVideo(learnerId: number, componentProgressId: number, id: string): Promise<ExplainVideoView> {
  const response = await apiClient.post<ApiResponse<ExplainVideoView>>(`${path(learnerId, componentProgressId)}/${encodeURIComponent(id)}/retry`)
  return response.data.data
}

export async function deleteCoachingVideo(learnerId: number, componentProgressId: number, id: string): Promise<void> {
  await apiClient.delete(`${path(learnerId, componentProgressId)}/${encodeURIComponent(id)}`)
}
